import { Profile } from "./profile";
import { Address } from "./address";
import { Hotel } from "./hotel";

/**
 * User interface for the extranet system.
 *
 * Uses the access area permission model:
 * - Hotel users: access_areas[] determines which pages they can access
 * - Internal users: internal_role determines their role (super-admin, customer-success, viewer-system)
 */
export class User {
  id!: number;
  email!: string;
  password!: string;
  name!: string;
  token!: string;

  // Account status
  is_active?: boolean;
  // Earliest confirmed 2FA authenticator's confirmation time; null while 2FA is off
  two_factor_confirmed_at?: string | null;

  // Preferred UI language ('de' | 'fr' | 'it' | 'en'). Persisted on the
  // backend so the choice follows the user across devices/browsers.
  locale?: string;

  // Access area permission system
  access_areas?: string[]; // Access area slugs: ['bookings', 'availability-pricing', ...]
  internal_role?: string | null; // 'super-admin', 'customer-success', 'viewer-system', or null
  is_internal?: boolean; // true if user is HotelCard staff (has a system-wide role)

  // Shared fields
  email_hash?: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  delete_reason?: string | null;
  is_confirmed?: number;
  hcch_id?: string | null;
  is_temporary?: number;
  last_reminder?: string | null;
  last_login?: string;
  currency?: string;
  email_verified_at?: string | null;
  sent_recommend?: number;
  device_token?: string;
  recommend_code?: string;
  profile!: Profile;
  addresses?: {
    BILLING: Address[];
  };
  hotels?: number | Hotel[]; // Can be count (old) or array of hotels (new)
  bookings?: number;
  profile_complete_status?: boolean;
}
